import React, {PureComponent, CSSProperties} from 'react'
import {inject} from 'mobx-react'
import cxs from 'cxs/component'
import Store from 'Store'
import Theme, {mediaQueries} from 'Theme'
import {t} from 'helpers/i18n'
import History from 'helpers/History'
import {sections} from 'scenes/Main'
import {Button, Icon} from 'elements'

interface Props {
  store?: Store
}

interface State {
  selectedSection?: {
    name: string
    links: {
      name: string
      path: string
    }[]
  }
  activePath?: string
}

@inject('store')
class NavBar extends PureComponent<Props, State> {
  state: State = {
    selectedSection: undefined,
    activePath: undefined
  }

  constructor(props: Props) {
    super(props)
    const currentPath = (pathRegex.exec(History.location.pathname) || [])[1]
    const selectedSection = currentPath
      ? sections(props.store!.users.user).find(
          section =>
            section.links.find(link => link.path.indexOf(currentPath) > -1)
              ? true
              : false
        )
      : undefined
    this.state.selectedSection = selectedSection
    this.state.activePath = currentPath
  }

  handleSection = (selectedSection?) => () => {
    this.setState({selectedSection})
    if (selectedSection) this.handleLink(selectedSection.links[0].path)()
  }

  handleLink = activePath => () => {
    this.setState({activePath})
    History.push(activePath)
  }

  render() {
    const {selectedSection} = this.state
    return (
      <Wrapper>
        {selectedSection ? (
          <Button onClick={this.handleSection()}>
            <Icon name="back" />
          </Button>
        ) : null}
        {!selectedSection
          ? sections(this.props.store!.users.user).map(section => (
              <StyledButton
                key={section.name}
                onClick={this.handleSection(section)}>
                {t(section.name)}
              </StyledButton>
            ))
          : selectedSection.links.map(link => (
              <StyledButton
                key={link.name}
                primary={isActive(link.path)}
                onClick={this.handleLink(link.path)}>
                {t(link.name)}
              </StyledButton>
            ))}
      </Wrapper>
    )
  }
}

export default NavBar

const Wrapper = cxs('div')({
  display: 'flex',
  height: Theme.size.bar,
  borderTop: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
  backgroundColor: Theme.color.background
} as CSSProperties)

const StyledButton = cxs(Button)({
  flex: 1
} as CSSProperties)

const pathRegex = /\/(\w*)/
// const pathRegex = /\/.*?\/(\w*)/

const isActive = (_path: string) => {
  const currentPath = (pathRegex.exec(History.location.pathname) || [])[1]
  const path = (pathRegex.exec(_path) || [])[1]
  return currentPath === path
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/NavBar.tsx